// src/types/roles.ts
export enum UserRole {
    Admin = "Admin",
    Manager = "Manager",
    Operator = "Operator",
    Client="Client",
  }
  